.MenuContainer {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  display: flex;
  width: 100%;
  z-index: 999;
}
.Menu {
  /* border: 1px solid var(--colori-neutri-white); */
  background: var(--primary);
  box-shadow: -20px 0px 30px 4px rgba(0, 0, 0, 0.2);

  
  height: 100%;
  width: 70%;
  padding: 32px 24px;
}

.TitleMenu {
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  color: var(--colori-neutri-white);
}

.SloganUser {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 8px;
  color: var(--colori-neutri-gray-2);
}

.ListItemMenu {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  font-family: var(--font-roboto-slab);
  display: flex;
  align-items: center;
  color: var(--secondary-variant);
  cursor: pointer;
  padding: 8px;
  text-decoration: none;
}

.ListItemMenu:hover {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 100px;
}

.ListItemOptionSelected {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  font-family: var(--font-roboto-slab);
  color: var(--colori-neutri-gray-2);
}




.ResponseOverlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.2);
  padding: 24px 16px;
  overflow-y: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ResponseContainer {
  display: flex;
  width: 100%;
  height: 592px;
  padding: 16px 64px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  gap: 71px;
  flex-shrink: 0;
  border-radius: 5px;
  background: var(--overlay);
}

.ButtonAccetta {
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  width: 100%;
  align-self: stretch;
  border-radius: 5px;
  background: var(--concorso);
  /* Shade Button Blu */
  box-shadow: 1px 1px 0px 0px var(--concorso-shadow);
  border: none;
  color: var(--colori-neutri-white, #fff);
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}